// Navigation structure for Portico Systems
export const navigationItems = [
  {
    id: "about",
    label: "About Us",
    href: "/about",
    hasDropdown: true,
    dropdown: {
      sections: [
        {
          title: "Company",
          links: [
            { label: "Our Story", href: "/about#our-story" },
            { label: "Our Process", href: "/about#our-process" },
            { label: "What Sets Us Apart", href: "/about#what-sets-us-apart" },
            { label: "Our Team", href: "/about#our-team" },
            { label: "Careers", href: "/about#careers" }
          ]
        }
      ],
      featured: {
        title: "25+ Years of Excellence",
        description: "Leading commercial flooring solutions for high-traffic environments.",
        image: "/Assets/images/00_global/Navigation/01_About-Us/feature_AboutUs_Why-Work-with-us.jpg",
        cta: { label: "Learn More", href: "/about" }
      }
    }
  },
  {
    id: "shop",
    label: "Products",
    href: "/products",
    hasDropdown: true,
    dropdown: {
      sections: [
        {
          title: "Categories",
          links: [
            { label: "Broadloom Rolls & Sheets", href: "/products?category=broadloom" },
            { label: "Carpet Tile", href: "/products?category=carpet-tile" },
            { label: "Custom Logo Mats", href: "/products?category=custom-logo-mats" },
            { label: "Luxury Vinyl Plank & Tile", href: "/products?category=luxury-vinyl" },
            { label: "Grid Entry Systems", href: "/products?category=grid-entry-systems" },
            { label: "Commercial Mats", href: "/products?category=commercial-mats" },
            { label: "Industrial & Anti-Fatigue", href: "/products?category=industrial-anti-fatigue" },
            { label: "Non-Slip Flooring", href: "/products?category=non-slip-flooring" },
            { label: "Recycled Rubber Flooring", href: "/products?category=recycle-rubber" },
            { label: "Accessories", href: "/products?category=accessories" }
          ]
        },
        {
          title: "Product Zone Comparison",
          links: [
            { label: "Zone 1 - Exterior Entry", href: "/products?zones=1-2,1-2-3" },
            { label: "Zone 2 - Vestibule", href: "/products?zones=1-2,2-3,1-2-3" },
            { label: "Zone 3 - Interior Space", href: "/products?zones=2-3,1-2-3" }
          ]
        },
        {
          title: "Product Tools",
          links: [
            { label: "Compare Products", href: "/compare" },
            { label: "Guided Flooring Selector", href: "/flooring-selector" }
          ]
        }
      ],
      featured: {
        title: "Custom Solutions Division",
        description: "Explore our most popular customization services from Logo Mats to Full-Scope Installations.",
        image: "/Assets/images/00_global/Navigation/02_Products/custom-solutions-thumbnail.jpg",
        link: "/custom",
        cta: { label: "View All Products", href: "/products" }
      }
    }
  },
  {
    id: "solutions",
    label: "Solutions",
    href: "/solutions",
    hasDropdown: true,
    dropdown: {
      sections: [
        {
          title: "By Industry",
          links: [
            { label: "Corporate Offices", href: "/solutions#corporate-offices" },
            { label: "Retail", href: "/solutions#retail" },
            { label: "Hospitality", href: "/solutions#hospitality" },
            { label: "Grocery & Convenience", href: "/solutions#grocery-convenience" },
            { label: "Healthcare", href: "/solutions#healthcare" },
            { label: "Education", href: "/solutions#education" }
          ]
        },
        {
          title: "Zone Defense System",
          links: [
            { label: "Zone 1 - First Line Defense", href: "/solutions#zone-1" },
            { label: "Zone 2 - Vestibule & Airlock", href: "/solutions#zone-2" },
            { label: "Zone 3 - Interior Protection", href: "/solutions#zone-3" }
          ]
        }
      ],
      featured: {
        title: "Zone Defense System",
        description: "Our comprehensive approach to protecting your floors from the outside in.",
        image: "/Assets/images/00_global/Navigation/03_Solutions/feature_Solutions_Talk-with-an-expert.jpg",
        cta: { label: "Explore Solutions", href: "/solutions" }
      }
    }
  },
  {
    id: "resources",
    label: "Resources",
    href: "/resources",
    hasDropdown: true,
    dropdown: {
      sections: [
        {
          title: "Learn",
          links: [
            { label: "Featured Guides", href: "/resources#guides" },
            { label: "Expert Articles", href: "/resources#articles" },
            { label: "Video Library", href: "/resources#videos" },
            { label: "Product Maintenance", href: "/resources#maintenance" }
          ]
        },
        {
          title: "Technical",
          links: [
            { label: "Specifications", href: "/resources?type=specification" },
            { label: "Installation Guides", href: "/resources#installation" },
            { label: "LEED Information", href: "/resources#leed" }
          ]
        }
      ],
      featured: {
        title: "Sustainability",
        description: "Explore our sustainability resources to see how we're driving responsible, long-term impact.",
        image: "/Assets/images/00_global/Navigation/04_Resources/feature_Resources_LEED-Credits.jpg",
        cta: { label: "Discover More", href: "/resources?topic=Sustainability" }
      }
    }
  },
  {
    id: "contact",
    label: "Contact Us",
    href: "/contact",
    hasDropdown: false
  }
];

// Footer navigation
export const footerNavigation = {
  services: [
    { label: "Custom Solutions Hub", href: "/custom" },
    { label: "Concierge Service", href: "/concierge" },
    { label: "Design Consultation", href: "/custom/consultation" },
    { label: "Professional Installation", href: "/custom/installations" },
    { label: "Maintenance Program", href: "/maintenance" }
  ],
  quickLinks: [
    { label: "Home", href: "/" },
    { label: "About Us", href: "/about" },
    { label: "Products", href: "/products" },
    { label: "Solutions", href: "/solutions" },
    { label: "Resources", href: "/resources" },
    { label: "Contact Us", href: "/contact" }
  ],
  about: [
    { label: "Our Story", href: "/about#our-story" },
    { label: "Our Team", href: "/about#our-team" },
    { label: "Careers", href: "/about#careers" },
    { label: "Sustainability", href: "/resources?topic=Sustainability" },
    { label: "Staff Login", href: "/dashboard" }
  ],
  legal: [
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms of Service", href: "/terms" }
  ]
};

// Contact information
export const contactInfo = {
  headquarters: [
    {
      name: "HQ1",
      address: "102 Trade ST, Greer SC 29651",
      country: "United States"
    },
    {
      name: "HQ2", 
      address: "300 Union Grove Road SE, Calhoun GA 30701",
      country: "United States"
    }
  ],
  generalInquiries: {
    phone: "1-864-527-3148",
    tollFree: true
  },
  customerService: {
    phone: "1-877-285-8899",
    email: "support@porticosystems.com"
  },
  generalEmail: "info@porticosystems.com",
  businessHours: {
    days: "Monday - Friday",
    hours: "8:00 AM - 5:00 PM"
  },
  social: [
    { platform: "LinkedIn", url: "https://linkedin.com/company/porticosystems", icon: "linkedin" },
    { platform: "Facebook", url: "https://facebook.com/porticosystems", icon: "facebook" },
    { platform: "Instagram", url: "https://instagram.com/porticosystems", icon: "instagram" },
    { platform: "Pinterest", url: "https://pinterest.com/porticosystems", icon: "pinterest" }
  ]
};

// Team members - Using actual team photos from assets
export const teamMembers = {
  projectManagers: [
    {
      name: "Chris Pittman",
      title: "Product Manager",
      email: "cpittman@porticosystems.com",
      phone: "1-877-285-8899",
      image: "https://ui-avatars.com/api/?name=Chris+Pittman&background=003b71&color=fff&size=256&bold=true",
      linkedin: "#"
    },
    {
      name: "Bill Long",
      title: "National Accounts Project Manager",
      email: "blong@porticosystems.com",
      phone: "1-877-285-8899",
      image: "https://ui-avatars.com/api/?name=Bill+Long&background=003b71&color=fff&size=256&bold=true",
      linkedin: "#"
    },
    {
      name: "Arlen Smith",
      title: "National Accounts Project Manager",
      email: "asmith@porticosystems.com",
      phone: "1-877-285-8899",
      image: "https://ui-avatars.com/api/?name=Arlen+Smith&background=003b71&color=fff&size=256&bold=true",
      linkedin: "#"
    }
  ],
  sales: [
    {
      name: "Jason Arledge",
      title: "National Account Sales",
      email: "jarledge@porticosystems.com",
      phone: "1-877-285-8899",
      image: "/Assets/images/02_About-Us/Jason_Arledge.jpg",
      linkedin: "https://www.linkedin.com/in/jason-arledge-aa6a698a/"
    },
    {
      name: "Mike Bedford",
      title: "National Account Sales",
      email: "mbedford@porticosystems.com",
      phone: "1-877-285-8899",
      image: "/Assets/images/02_About-Us/Mike_Bedford.jpg",
      linkedin: "https://www.linkedin.com/in/mike-bedford-43b375104/"
    },
    {
      name: "Dennis Bishop",
      title: "National Account Sales",
      email: "dbishop@porticosystems.com",
      phone: "1-877-285-8899",
      image: "/Assets/images/02_About-Us/Dennis_Bishop.jpg",
      linkedin: "https://www.linkedin.com/in/dennis-bishop-a13a8b81/"
    },
    {
      name: "Michelle Buehler",
      title: "National Account Sales",
      email: "mbuehler@porticosystems.com",
      phone: "1-877-285-8899",
      image: "/Assets/images/02_About-Us/Michelle_Buehler.jpg",
      linkedin: "https://www.linkedin.com/in/michelle-buehler-75b676b/"
    },
    {
      name: "Adam Carter",
      title: "National Account Sales",
      email: "acarter@porticosystems.com",
      phone: "1-877-285-8899",
      image: "/Assets/images/02_About-Us/Adam_Carter.jpg",
      linkedin: "https://www.linkedin.com/in/adam-carter-92577810a/"
    },
    {
      name: "Greg Griffin",
      title: "SVP Sales",
      email: "ggriffin@porticosystems.com",
      phone: "1-877-285-8899",
      image: "/Assets/images/02_About-Us/Greg_Griffin.jpg",
      linkedin: "https://www.linkedin.com/in/greg-griffin-a6618115/"
    },
    {
      name: "Morgan Hyde",
      title: "National Account Sales",
      email: "mhyde@porticosystems.com",
      phone: "1-877-285-8899",
      image: "/Assets/images/02_About-Us/Morgan_Hyde.jpg",
      imagePosition: "center top",
      linkedin: "https://www.linkedin.com/in/morgan-hyde-682317174/"
    },
    {
      name: "Lawrence Orlando",
      title: "National Sales Manager - BD",
      email: "lorlando@porticosystems.com",
      phone: "1-877-285-8899",
      image: "/Assets/images/02_About-Us/Lawrence_Orlando.jpg",
      linkedin: "https://www.linkedin.com/in/lawrence-orlando-16804520/"
    }
  ]
};

// Testimonials - Using company logos from assets
export const testimonials = [
  {
    id: 1,
    quote: "At Caleres, we're focused on creating great in-store experiences. With Portico Systems supporting us, we've kept that promise with reliable materials and clear communication. Their partnership helps us deliver for customers every day.",
    author: "Joshua Perkins",
    title: "Manager, Store Construction, Store Planning",
    company: "CALERES",
    image: "/Assets/logos/Caleres_logo.png",
    isLogo: true
  },
  {
    id: 2,
    quote: "At The Aubuchon Company, flawless store projects are non-negotiable. Since partnering with Portico Systems, flooring is no longer a headache—they matched our pace and freed us to focus on customers. Project after project, we deliver with confidence, backed by a true partner.",
    author: "Mark Vassalli",
    title: "Director of Conversions & Store Projects",
    company: "AUBUCHON HARDWARE",
    image: "/Assets/logos/aubuchon-hardware-1600x510.jpg",
    isLogo: true
  },
  {
    id: 3,
    quote: "We needed flooring that could handle heavy traffic while making the right impression on clients—our old floors were holding us back. Working with Portico, we upgraded to LVT that's transformed our space into something that finally matches our professional standards, handles everything we throw at it, and requires almost no maintenance.",
    author: "The SkyZone Team",
    title: "Greenville, SC",
    company: "SKYZONE",
    image: "/Assets/logos/SkyZone_logo.svg",
    isLogo: true
  }
];

// Key metrics
export const metrics = [
  { value: "25+", label: "Years of Experience" },
  { value: "98%", label: "Client Satisfaction" },
  { value: "500+", label: "Industry Partners" }
];
